<div class="popup-wrapper">
    <div class="popup-header">
        <span class="material-icons-round cyan">local_offer</span>
        <span class="soc-panel-h">{{(editFlag ? 'INVENTORY_ITEM.EDIT_INVENTORY_ITEM' : "INVENTORY_ITEM.NEW_INVENTORY_ITEM") | translate}}</span>
    </div>
    <hr class="soc-panel-line">  
    <form #f="ngForm" class="soc-form-wrapper-gap-24">
        <div class="soc-input-wrapper">
            <label for="name" class="soc-input-lbl w-100 text-start">{{'INVENTORY_ITEM.ITEM_NAME'| translate}}</label>
            <div class=" soc-error-field-wrapper">
                <span *ngIf="name.invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}" tooltipPosition="top" class="material-icons soc-error-icon">info</span>
                <input [ngClass]="{'soc-error-active': name.invalid && f.submitted}" id="name" required name="name"  #name="ngModel" type="text" class="soc-input-field soc-input-text" placeholder="{{'TYPE_HERE' | translate}}" [(ngModel)]="inventoryItem.name">
            </div>
        </div>
        <div class="soc-input-wrapper">
            <label for="unit" class="soc-input-lbl w-100 text-start">{{'INVENTORY_ITEM.MEASUREMENT_UNIT' | translate}}</label>
            <div class="soc-error-field-wrapper">
                <span *ngIf="unit.invalid && f.submitted"  pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}"  tooltipPosition="top" class="material-icons soc-error-icon" >info</span>
                <p-dropdown [ngClass]="{'soc-error-active-dropdown': unit.invalid && f.submitted}" [required]="true" id="unit" name="unit" #unit="ngModel" appendTo="body" class="soc-dropdown soc-dropdown-search-separator" [options]="measurementUnits" [(ngModel)]="inventoryItem.unitType" optionLabel="name" optionValue="name" [showClear]="true"  placeholder="{{'INVENTORY_ITEM.SELECT_UNIT' | translate}}" ></p-dropdown>
            </div>
        </div>
        <hr class="soc-panel-line">
        <div class="soc-wrapper-gap-12 d-flex justify-content-end">
            <button class="soc-secondary-grey-btn" type="button" (click)="close()">{{'CLOSE'| translate}}</button>
            <button class="soc-basic-cyan-btn" type="submit" (click)="save(f)">{{(editFlag ? 'SAVE_CHANGES' : 'CREATE')| translate}}</button>
        </div>
    </form>
</div>
